module.exports = __webpack_public_path__ + "09_2x.jpg?4ec5097c1bd012b675b44c69f72229a1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/09_2x.jpg
// module id = 83
// module chunks = 0